import {useCallback} from 'react';

import {getOrderReviewTotalsApi} from 'api/custom';
import {ENDPOINTS} from 'constants/endpoints';
import {getTotalsShippingProtection} from 'desktop/pages/checkout/store/selectors/orderReviewTotals/orderReviewTotals';
import {ApplicationStoreType} from 'desktop/store';
import {getPayPalOrderDataFromTotals} from 'features/expressPayments/payPalV3/utils/getTokenPayPal';
import {useSelectorRef} from 'hooks/useSelectorRef/useSelectorRef';
import {apiConfig} from 'libs/api/api';
import {ShippingMethodType} from 'types/shippingMethodsType';

/**
 * Get totals and call paypal update endpoint to update in iframe
 */
export const useGetAndUpdateTotals = () => {
    const shippingProtectionFromCheckoutRef = useSelectorRef(getTotalsShippingProtection);
    const shippingProtectionFromCartRef = useSelectorRef(
        (state: ApplicationStoreType) => state.cart.totals.shippingProtectionPrice || 0,
    );

    const getAndUpdateTotals = useCallback(
        async (id: string, availableShippings: ShippingMethodType[]) => {
            const shippingProtectionFromCheckout = shippingProtectionFromCheckoutRef.current?.price;
            const shippingProtectionPriceFromCart = shippingProtectionFromCartRef.current;

            const {data: totals} = await getOrderReviewTotalsApi({
                collectTax: true,
                withTaxErrors: true,
            });

            await apiConfig.instanceGusaBackend.request({
                baseURL: apiConfig.API_URL,
                data: getPayPalOrderDataFromTotals({
                    shippingAddress: null,
                    shippingMethodsList: availableShippings,
                    shippingProtectionPrice:
                        shippingProtectionFromCheckout || shippingProtectionPriceFromCart,
                    totals,
                }),
                method: 'put',
                url: String(ENDPOINTS.PAYPAL_UPDATE({id})),
            });
        },
        [shippingProtectionFromCartRef, shippingProtectionFromCheckoutRef],
    );

    return getAndUpdateTotals;
};
